export default __webpack_public_path__ + "static/media/not-assigned.d9988b21.jpg";